"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var react_1 = __importDefault(require("react"));
var dividerModule = require("./Divider.module.scss");
var Divider = function (_a) {
    var style = _a.style, orientacao = _a.orientacao;
    var orientacaoStyle = orientacao || "horizontal";
    return react_1.default.createElement("div", { className: dividerModule[orientacaoStyle], style: style });
};
exports.Divider = Divider;
